import { useMemo } from "react";

import { StatusEnum } from "@/pages/scenario-builder/types";
import {
  ScenarioOption,
  scenarioOptionFromScenario,
} from "@/pages/scenario-builder/v3/components/NewActionPlanModal/types";

import { useScenariosV2 } from "../api/v2/getScenarios";

export const useEligibleActionPlanScenarios = () => {
  const { data: scenarios, isLoading } = useScenariosV2();

  const eligibleScenarios = useMemo((): ScenarioOption[] => {
    if (!scenarios) return [];
    return scenarios
      .filter(
        (scenario) =>
          (scenario.status === StatusEnum.Approved || scenario.status === StatusEnum.Completed) &&
          scenario.isEligibleForActionPlans
      )
      .map((scenario) => scenarioOptionFromScenario(scenario));
  }, [scenarios]);

  return { eligibleScenarios, isLoading };
};
